// extracted by mini-css-extract-plugin
export default {"content":"index_content_oHoiO","pageTitle":"index_pageTitle_RTeyv","list":"index_list_IQN8F","articleLink":"index_articleLink_lIJgB","columnLink":"index_columnLink_6vtsi"};